
define('ldsh!modules/form_editor/templates/editor_custom_password', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="editor-form-group ed-form-group">\n  <label class="control-label" for="" data-i18n="[text]formEditor.placeholder">Texto por defecto</label>\n  <input type="text" class="form-control js-placeholder js-telephone" value="' +
((__t = ( placeholder )) == null ? '' : __t) +
'">\n</div>\n\n<div class="ed-form-group">\n  <div class="md__checkbox--wrapper">\n    <input\n      id="confirmation"\n      name="confirmation"\n      type="checkbox"\n      class="md__checkbox--primary js-filter-hidden js-confirmation"\n      ' +
((__t = ( confirmationChecked ? 'checked': '' )) == null ? '' : __t) +
'\n    />\n    <label\n      for="confirmation"\n      data-i18n="formEditor.passwordConfirmation"\n    ></label>\n  </div>\n</div>\n\n<div class="editor-form-group ed-form-group ' +
((__t = ( confirmation ? '' : 'hidden' )) == null ? '' : __t) +
'">\n  <label\n    class="control-label"\n    data-i18n="[text]formEditor.passwordConfirmationLabel"\n  >Etiqueta de la confirmación</label>\n  <input\n    type="text"\n    class="form-control ed-input-group js-confirmation-label"\n    value="' +
((__t = ( confirmationLabel )) == null ? '' : __t) +
'"\n  />\n</div>\n\n<div class="editor-form-group ed-form-group ' +
((__t = ( confirmation ? '' : 'hidden' )) == null ? '' : __t) +
'">\n  <label\n    class="control-label"\n    data-i18n="[text]formEditor.passwordConfirmationPlaceholderLabel"\n  >Texto por defecto de la confirmación</label>\n  <input\n    type="text"\n    class="form-control ed-input-group js-confirmation-placeholder"\n    value="' +
((__t = ( confirmationPlaceholder )) == null ? '' : __t) +
'"\n  />\n</div>\n';

}
return __p
};});

